import React, { ReactNode } from 'react';

type StepProps = {
  children: ReactNode;
  id: string;
  index?: number;
  isLastStep?: boolean;
};

export const StepContent = ({ children }: { children: ReactNode }) => {
  const childArray = React.Children.toArray(children).filter(
    (child) => React.isValidElement(child) && child.type === Step,
  );

  return (
    <div className="relative w-full px-8 pb-14 pt-12">
      {childArray.map((child, index) => {
        const stepElement = child as React.ReactElement<StepProps>;
        const stepId = stepElement.props.id;

        return (
          <React.Fragment key={stepId}>
            {React.cloneElement(stepElement, {
              index: index + 1,
              isLastStep: index === childArray.length - 1,
            })}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export const Step = ({ children, id, index, isLastStep }: StepProps) => {
  return (
    <div className="relative mb-16 px-10" id={id}>
      <div className="text-heading-lg absolute -left-6 flex size-10 items-center justify-center rounded-full border-[1.33px] border-primary">
        {index}
      </div>
      {!isLastStep && (
        <div className="absolute -bottom-[64px] -left-1 top-[40px] border-l border-primary" />
      )}
      {children}
    </div>
  );
};
